import { msg } from "@lingui/core/macro";

export const startDateRuleMessages = {
	name: msg({ message: "Fixed Start Date" }),
	description: msg({ message: "Permit Start Date is Set" }),
	errors: {
		dateMismatch: msg({ message: "Permit must start on {date}" }),
	},
} as const;
